import { Tecnico } from './../tecnico.model';
import { EquipeService } from './../../equipe/equipe.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { ActivatedRoute } from '@angular/router';

import { } from '@types/googlemaps';
import { formataDataHora } from '../../app.config';
import { TecnicoService } from './../tecnico.service';

@Component({
  selector: 'ntc-mapa-tecnico',
  templateUrl: './mapa-tecnico.component.html',
  styleUrls: ['./mapa-tecnico.component.css']
})

export class MapaTecnicoComponent implements OnInit {
  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;

  latLngCenter = {Lat: null, Lng: null};
  marcadorLabel = 'ABCDEFGHIJKLMNOPQRXYZ';

  /*
  marcadores = [
    {
        IdOs: 1,
        DtAgendamento: '27/1/2018',
        HrAgendamento: '21:00',
        Assinante: 'Eidi NTech Soluções',
        IdProtocolo: 123,
        IdEquipe: 1,
        Equipe: 'Equipe Técnica Interna',
        EstadoAndamento: '2',
        LatLngAtendimento: '-23.4262833,-51.9380537',
        OsTecnicoDeslocamento: {
            IdOrdemServico: 1,
            IdPessoa: '1',
            Tecnico: 'Akira Higa',
            DtHrInicioDeslocamento: '2018-03-05T11:01:11.060Z',
            DtHrFimDeslocamento: '2018-03-05T18:38:34.411Z',
            DtHrInicioAtendimento: '2018-03-06T13:04:17.305Z',
            DtHrFimAtendimento: '2018-03-06T13:04:19.314Z',
            Observacao: 'obs1',
            Id: 11
        }
    },
    {
      IdOs: 2,
      DtAgendamento: '27/1/2018',
      HrAgendamento: '21:00',
      Assinante: 'Eidi NTech Soluções',
      IdProtocolo: 1234,
      IdEquipe: 1,
      Equipe: 'Equipe Técnica Interna',
      EstadoAndamento: '6',
      LatLngAtendimento: '-23.415529,-51.9389668',
      OsTecnicoDeslocamento: {
          IdOrdemServico: 1,
          IdPessoa: '1',
          Tecnico: 'Akira Higa',
          DtHrInicioDeslocamento: '2018-03-05T11:01:11.060Z',
          DtHrFimDeslocamento: '2018-03-05T18:38:34.411Z',
          DtHrInicioAtendimento: '2018-03-06T13:04:17.305Z',
          DtHrFimAtendimento: '2018-03-06T13:04:19.314Z',
          Observacao: 'obs2',
          Id: 12
      }
    },
    {
      IdOs: 3,
      DtAgendamento: '27/1/2018',
      HrAgendamento: '21:00',
      Assinante: 'Eidi NTech Soluções',
      IdProtocolo: 12345,
      IdEquipe: 1,
      Equipe: 'Equipe Técnica Interna',
      EstadoAndamento: '7',
      LatLngAtendimento: '-23.4277935,-51.9308353',
      OsTecnicoDeslocamento: {
          IdOrdemServico: 1,
          IdPessoa: '1',
          Tecnico: 'Akira Higa',
          DtHrInicioDeslocamento: '2018-03-05T11:01:11.060Z',
          DtHrFimDeslocamento: '2018-03-05T18:38:34.411Z',
          DtHrInicioAtendimento: '2018-03-06T13:04:17.305Z',
          DtHrFimAtendimento: '2018-03-06T13:04:19.314Z',
          Observacao: 'obs3',
          Id: 13
      }
    }
  ];
  */
  marcadores = [];

  marcadoresPolylinesPath = [];

  iconColor = '#FFF';

  listaTecnico = [];
  listaEquipe = [];

  idTecnico = 0;
  objTecnico: Tecnico = new Tecnico;

  loadingVisible = false;

  constructor(
    private tecnicoService: TecnicoService,
    private equipeService: EquipeService,
    private route: ActivatedRoute
  ) {
    if (this.route.snapshot.params['idTecnico'] !== undefined) {
      this.idTecnico = this.route.snapshot.params['idTecnico'];
    } else {
      this.idTecnico = 0;
    }
  }

  criarMapa() {
  // Criando o Mapa
    const mapProp = {
      center: new google.maps.LatLng(this.latLngCenter.Lat, this.latLngCenter.Lng),
      zoom: 13,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);

    // InfoWindow Padrão (cria somente 1 infoWindow para apresentar sempre o mesmo componente, modificando o conteúdo somente)
    const infoWindow = new google.maps.InfoWindow({
      content: ''
    });

    // Marcadores (Markers)
    // for (const marcador of this.marcadores) {
    for (let i = 0; i < this.marcadores.length; i++) {
      const marcador = this.marcadores[i];

      const posicaoLatLong = marcador.LatLngAtendimento.split(',');

      this.marcadoresPolylinesPath.push({
        lat: +posicaoLatLong[0],
        lng: +posicaoLatLong[1]
      });

      // verificar a cor do marcador de acordo com o "Estado da O.S."
      /*
        #488aff = azul
        #32db64 = verde
        #f53d3d = vermelho
      */
      if ((marcador.EstadoAndamento === '2') || (marcador.EstadoAndamento === 2)) {
        this.iconColor = '#488aff';
      } else if ((marcador.EstadoAndamento === '6') || (marcador.EstadoAndamento === 6)) {
        this.iconColor = '#32db64';
      } else if ((marcador.EstadoAndamento === '7') || (marcador.EstadoAndamento === 7)) {
        this.iconColor = '#f53d3d';
      } else {
        this.iconColor = '#FFFFFF';
      }

      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(+posicaoLatLong[0], +posicaoLatLong[1]),
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 12,
          fillColor: this.iconColor,
          fillOpacity: 1,
          strokeWeight: 4,
          strokeColor: '#343a40'
        },
        label: {
          color: '#FFFFFF',
          fontWeight: 'bold',
          text: this.marcadorLabel[i]
        },
        map: this.map
      });

      // evento click do marcador
      marker.addListener('click', function() {
        const contentString = '<div>' +
                              '<p>Marcador ' + marker.getLabel().text + '</p>' +
                              '<p>Assinante: ' + marcador.Assinante + '</p>' +
                              '<p>O.S: ' + marcador.IdOs + '</p>' +
                              '<p>Protocolo: ' + marcador.IdProtocolo + '</p>' +
                              '<p>Equipe: ' + marcador.Equipe + '</p>' +
                              '<p>Tecnico: ' + marcador.OsTecnicoDeslocamento.Tecnico + '</p>' +
                              '<p>Agendamento: ' + marcador.DtAgendamento + ' - ' + marcador.HrAgendamento + '</p>' +
                              '<p>Atendimento: ' +
                                formataDataHora(new Date(marcador.OsTecnicoDeslocamento.DtHrInicioAtendimento)) + '</p>' +
                              '</div>';
        infoWindow.setContent(contentString);
        infoWindow.open(this.map, marker);
      });

    }

    // Linhas (Polylines)
    const polyLines = new google.maps.Polyline({
      path: this.marcadoresPolylinesPath,
      geodesic: true,
      strokeColor: '#343a40',
      strokeOpacity: 0.8,
      strokeWeight: 3
    });

    polyLines.setMap(this.map);

  }

  ngOnInit() {
    this.loadingVisible = true;

    // Se for a rota do mapa de um tecnico específico, não carrega a lista
    if (this.idTecnico === 0) {
      // Carrega lista de equipes
      this.equipeService.getEquipes().subscribe(equipes => {
        this.listaEquipe = equipes;
      },
      error => {
        notify('Erro ao carregar Equipes!', 'error', 2000);
      });

      // Carrega lista de tecnicos
      this.tecnicoService.getTecnicos().subscribe(tecnicos => {
        this.listaTecnico = tecnicos;
      },
      error => {
        notify('Erro ao carregar Técnicos!', 'error', 2000);
      });

      this.latLngCenter.Lat = -23.4262833;
      this.latLngCenter.Lng = -51.9380537;
      this.criarMapa();
    } else {
      this.carregarDadosMapa();
    }

/*
    const markers1 = new google.maps.Marker();
    const markers2 = new google.maps.Marker();
    const markers3 = new google.maps.Marker();
    const markers4 = new google.maps.Marker();
    const markers5 = new google.maps.Marker();

    const iconTecnico = 'assets/tecnico-icon-32.png';

    const posicaoCentro = new google.maps.LatLng(-23.4262833, -51.9380537);
    markers1.setMap(this.map);
    markers1.setPosition(posicaoCentro);
    //markers1.setIcon(iconTecnico);
    markers1.setLabel('A');
    markers1.setTitle('Titulo A');

    const contentString1 = '<div><h1>Marcador A</h1></div>';
    const infoWindow1 = new google.maps.InfoWindow({
      content: contentString1
    });

    markers1.addListener('click', function() {
      infoWindow1.open(this.map, markers1);
    });

    const pos1 = new google.maps.LatLng(-23.415529, -51.9389668);
    markers2.setMap(this.map);
    markers2.setPosition(pos1);
    markers2.setIcon(iconTecnico);

    const pos2 = new google.maps.LatLng(-23.4277935, -51.9308353);
    markers3.setMap(this.map);
    markers3.setPosition(pos2);
    markers3.setIcon(iconTecnico);

    const pos3 = new google.maps.LatLng(-23.4301733, -51.9602277);
    markers4.setMap(this.map);
    markers4.setPosition(pos3);
    markers4.setIcon(iconTecnico);

    const pos4 = new google.maps.LatLng(-23.4212821, -51.9206824);
    markers5.setMap(this.map);
    markers5.setPosition(pos4);
    markers5.setIcon(iconTecnico);
*/
    this.loadingVisible = false;
  }

  carregarDadosMapa() {
    this.tecnicoService.getTecnicoById(this.idTecnico.toString()).subscribe(tecnico => {
      this.objTecnico = tecnico;
      this.tecnicoService.getDadosMapaOSById(this.idTecnico.toString()).subscribe(dadosMapa => {
        this.marcadores = dadosMapa;
        if ( ( this.marcadores.length !== undefined ) && ( this.marcadores.length > 0 )  ) {
          const LatLngInicial = this.marcadores[0].LatLngAtendimento.split(',');
          this.latLngCenter.Lat = LatLngInicial[0];
          this.latLngCenter.Lng = LatLngInicial[1];
        } else {
          this.latLngCenter.Lat = -23.4262833;
          this.latLngCenter.Lng = -51.9380537;
        }
        this.criarMapa();
      });
    },
    error => {
      notify('Erro ao carregar dados do Mapa!', 'error', 2000);
    });
  }

  verificaTecnicoInformado() {
    if (this.idTecnico > 0) {
      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/tecnico/mapa-tecnico/mapa-tecnico.component.ts